module.exports = __webpack_public_path__ + "static/img/logoopen.a3bae975.png";